export default {"src":"/_next/static/media/logo-light.c7cac5fb.svg","height":60,"width":95};